import { render, staticRenderFns } from "./ActivateResponsibilityConfirmationModal.vue?vue&type=template&id=4c17acb4&scoped=true"
import script from "./ActivateResponsibilityConfirmationModal.vue?vue&type=script&lang=js"
export * from "./ActivateResponsibilityConfirmationModal.vue?vue&type=script&lang=js"
import style0 from "./ActivateResponsibilityConfirmationModal.vue?vue&type=style&index=0&id=4c17acb4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c17acb4",
  null
  
)

export default component.exports